import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import {SkyLightStateless} from 'react-skylight';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Table, Breadcrumb } from 'react-bootstrap';
import { Field } from 'redux-form';
import _ from 'lodash';
import { Translate, Localize, I18n } from 'react-redux-i18n';
import axios from 'axios';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import UserPassword from '../../containers/Settings/userPassword';
import { InputField, PasswordInputField, DisabledInputField } from '../Common/inputField';
import ConfirmActionModal from '../Common/confirmActionModal';
import { Selection, SelectionWithProps } from '../Common/selection';
import UserName from './userName';
import { RESET_PASSWORD_URL, DELETE_USER_URL } from '../../actions/url';
import {
  ROOT_URL, ROOT_API_URL, isHMM, isOCM, isSV, isVAK, isKM
} from '../../actions/root_url';
import TranslateNamePermission from '../../containers/TranslatePermission/translate';

const positionOptions = [{
  label: '----',
  value: '',
}, {
  label: 'Manager',
  value: 'Manager',
}];

class RowRenderer extends Component {
  PropTypes: {
    onDoubleClick: React.PropTypes.func
  }

  render() {
    //here we are just changing the style
    //but we could replace this with anything we liked, cards, images, etc
    //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
    return (<div onDoubleClick={()=>{this.props.onDoubleClick(this.props.row)}}><ReactDataGrid.Row ref="row" {...this.props} /></div>)
  }
}

class DisableRowRenderer extends Component {
  PropTypes: {
    onDoubleClick: React.PropTypes.func
  }

  render() {
    //here we are just changing the style
    //but we could replace this with anything we liked, cards, images, etc
    //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
    return (<div><ReactDataGrid.Row ref="row" {...this.props} style={{'background-color': 'gray'}}/></div>)
  }
}

class UserManagementDetail extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      dirty: false,
      groupName: '',
      groups: {
        rows: [],
        selectedRows: null,
        filters: {},
        sortColumn: null,
        sortDirection: null
      },
      userGroups: {
        rows: [],
        selectedRows: null,
        filters: {},
        sortColumn: null,
        sortDirection: null
      },
      permissions: {
        rows: [],
        selectedRows: null,
        filters: {},
        sortColumn: null,
        sortDirection: null
      },
      currentPermissions:[],

      userPermissions: {
        rows: [],
        selectedRows: null,
        filters: {},
        sortColumn: null,
        sortDirection: null
      },
      currentUserPermissions: [],
      groupPermissions: {
        rows: [],
        selectedRows: null,
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      assignCustomerOpen: false,
      editUserNameOpen: false,
      editPasswordOpen: false,
      showPasswordPopup: false,
      deleteUserPopup: false,

      admin: 'no',
      IsOfficeOnly: false,
    };
    this.moveToUserGroups = this.moveToUserGroups.bind(this);
    this.moveOffUserGroups = this.moveOffUserGroups.bind(this);
    this.moveToUserPermissions = this.moveToUserPermissions.bind(this);
    this.moveOffUserPermissions = this.moveOffUserPermissions.bind(this);
    this.moveAllPermissions = this.moveAllPermissions.bind(this);
    this.moveSelectedPermissions = this.moveSelectedPermissions.bind(this);
    this.openAssignCustomer = this.openAssignCustomer.bind(this);
    this.closeAssignCustomer = this.closeAssignCustomer.bind(this);
    this.openEditUserName = this.openEditUserName.bind(this);
    this.closeEditUserName = this.closeEditUserName.bind(this);
    this.openEditPassword = this.openEditPassword.bind(this);
    this.closeEditPassword = this.closeEditPassword.bind(this);
    this.checkAuthorize = this.checkAuthorize.bind(this);
    this.openResetPasswordPopup = this.openResetPasswordPopup.bind(this);
    this.closeResetPasswordPopup = this.closeResetPasswordPopup.bind(this);
    this.openDeleteUserPopup = this.openDeleteUserPopup.bind(this);
    this.closeDeleteUserPopup = this.closeDeleteUserPopup.bind(this);
  }

  componentDidMount() {
    if(this.props.currentUser) {
      this.props.fetchUserDetail(this.props.currentUser)
      .then(() => {
        this.props.resetUserDetail();
        this.props.fetchGroups();
        this.props.fetchPermissions();
      });
    }
    else {
      this.props.resetUserDetail();
      this.props.fetchGroups();
      this.props.fetchPermissions();
    }
    
    if(isKM){
      this.props.fetchActiveCustomers();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userDetail && nextProps.userDetail != this.props.userDetail) {
      let cpDetail = {...nextProps.userDetail};
      let userPermissions = {...this.state.userPermissions, rows: cpDetail.permissions.sort((a,b) => {return a.name.localeCompare(b.name)})};
      let userGroups = {...this.state.userGroups, rows: cpDetail.groups.sort((a,b) => {return a.name.localeCompare(b.name)})};
      let permissions = {...this.state.permissions};
      let groups = {...this.state.groups};
      userPermissions.rows.map(
        row => {
          let index = _.findIndex(permissions.rows, { permission_ptr_id: row.permission_ptr_id });
          if (index > -1) { permissions.rows.splice(index, 1); }
        }
      );
      userGroups.rows.map(
        row => {
          let index = _.findIndex(groups.rows, { group_ptr_id: row.group_ptr_id });
          if (index > -1) { groups.rows.splice(index, 1); }
        }
      );
      let currentUserPermissions = [];
      if(isVAK) {
        currentUserPermissions.push(...userPermissions.rows);
      }
      this.setState({userPermissions, userGroups, permissions, groups, IsOfficeOnly: nextProps.userDetail.IsOfficeOnly, currentUserPermissions});
      this.handleCompanySelect({ value: nextProps.userDetail.Company_id }, () => {
        this.props.changeFieldValue('Warehouse_id', nextProps.userDetail.Warehouse_id);
      });
    }
    if (nextProps.groupDetail && nextProps.groupDetail != this.props.groupDetail) {
      let groupPermissions = {...this.state.groupPermissions, rows: nextProps.groupDetail.permissions.sort((a,b) => {return a.name.localeCompare(b.name)})};
      this.setState({groupPermissions});
    }
    if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
      if (this.state.showPasswordPopup) {
        this.closeResetPasswordPopup();
        this.resetPassword();
      }
      if (this.state.deleteUserPopup) {
        this.closeDeleteUserPopup();
        this.deleteUser();  
        this.context.router.push('/userManagement');
      }
    }
    if (nextProps.permissions && nextProps.permissions != this.props.permissions) {
      let newRows = [...nextProps.permissions];
      let permissions = {...this.state.permissions, rows: newRows.sort((a,b) => {return a.name.localeCompare(b.name)})}
      let { userPermissions } = this.state;
      userPermissions.rows.map(
        row => {
          let index = _.findIndex(permissions.rows, { permission_ptr_id: row.permission_ptr_id });
          if (index > -1) { permissions.rows.splice(index, 1); }
        }
      );
      let currentPermissions = [];
      if(isVAK) {
        currentPermissions.push(...permissions.rows);
      }
      this.setState({permissions, currentPermissions});
    }
    if (nextProps.groups && nextProps.groups != this.props.groups) {
      let newRows = [...nextProps.groups];
      let groups = {...this.state.groups, rows: newRows.sort((a,b) => {return a.name.localeCompare(b.name)}) }
      let { userGroups } = this.state;
      userGroups.rows.map(
        row => {
          let index = _.findIndex(groups.rows, { group_ptr_id: row.group_ptr_id });
          if (index > -1) { groups.rows.splice(index, 1); }
        }
      );
      this.setState({groups});
    }
  }

  renderGroups() {
    if (this.props.groupsIsLoading && !this.props.groupsError) return <Spinner/>
    else if (this.props.groupsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.groupsError)}</div></ContentWrapper>
    else {
      // Parameters of the react-data-grid
      const getRows = () => {
        return Data.Selectors.getRows(this.state.groups);
      }

      const getSize = () => { return getRows().length; }

      const rowGetter = rowIdx => {
        var rows = getRows();
        return rows[rowIdx];
      }

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        var groups = Object.assign({}, this.state.groups, { sortColumn: sortColumn, sortDirection: sortDirection });
        this.setState({groups});
      }

      const handleFilterChange = filter => {
        let newFilters = Object.assign({}, this.state.groups.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const groups = {...this.state.groups, filters: newFilters};
        this.setState({ groups });
      }
      
      // Handle the row select function
      const onRowsSelected = (rows) => {
        let newRows = [...this.state.groups.rows];
        let selectedRows = [];
        rows.map (r => {
          newRows[r.rowIdx].isSelected = true;
          selectedRows.push(r.row);
        });
        if(this.state.groups.selectedRows) {
          selectedRows = selectedRows.concat(this.state.groups.selectedRows);
        }
        var groups = {...this.state.groups, rows: newRows, selectedRows: selectedRows}
        this.setState({groups});
      }
      
      const onRowsDeselected = (rows) => {
        let newRows = [...this.state.groups.rows];
        rows.map (r => {
         newRows[r.rowIdx].isSelected = false;
        });
        let selectedRows = [...this.state.groups.selectedRows];
        selectedRows = selectedRows.filter(function(obj){
          return obj.isSelected == true;
        })
        var groups = {...this.state.groups, rows: newRows, selectedRows: selectedRows};
        this.setState({groups});
      }

      const onRowClick = (rowIdx, row) => {
        this.setState({groupName: row.name}, () => { this.props.fetchGroupDetail(row.id) });
      }

      // Column difinition
      const columns = [
        {
          key: 'name',
          name: <Translate value={isVAK ? "group_name_role" : "group_name"} />,
          resizable: true,
          width: 250,
          sortable: true,
          filterable: true
        }
      ]

      return (
        <Col sm={ 4 }>
          <div style={{ maxWidth: '100%' }} id="UserManagementDetail-dataGrid1">
            <ReactDataGrid
              rowRenderer={<RowRenderer onDoubleClick={this.moveToUserGroups} />}
              rowKey='id'
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter={true}/>}
              onAddFilter={handleFilterChange}
              columns={columns}
              rowHeight={25}
              minHeight={265}
              rowGetter={rowGetter}
              rowsCount={ getSize() }
              onRowClick={onRowClick}
              // enableRowSelect='multi'
              //  rowSelection={{
              //    showCheckbox: true,
              //    enableShiftSelect: true,
              //    onRowsSelected: onRowsSelected,
              //    onRowsDeselected: onRowsDeselected,
              //    selectBy: {
              //     isSelectedKey: 'isSelected'
              //    }
              // }}
            />
          </div>
        </Col>
      )
    }
  }

  renderUserGroups() {
    if (this.props.groupsIsLoading && !this.props.groupsError) return <Spinner/>
    else if (this.props.groupsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.groupsError)}</div></ContentWrapper>
    else {
      // Parameters of the react-data-grid
      const getRows = () => {
        return Data.Selectors.getRows(this.state.userGroups);
      }

      const getSize = () => { return getRows().length; }

      const rowGetter = rowIdx => {
        var rows = getRows();
        return rows[rowIdx];
      }

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        var userGroups = Object.assign({}, this.state.userGroups, { sortColumn: sortColumn, sortDirection: sortDirection });
        this.setState({userGroups});
      }

      const handleFilterChange = filter => {
        let newFilters = Object.assign({}, this.state.userGroups.filters);
        if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
        } else {
            delete newFilters[filter.column.key];
        }
        const userGroups = {...this.state.userGroups, filters: newFilters};
        this.setState({ userGroups });
      }

      // Handle the row select function
      const onRowsSelected = (rows) => {
        let newRows = [...this.state.userGroups.rows];
        let selectedRows = [];
        rows.map (r => {
          newRows[r.rowIdx].isSelected = true;
          selectedRows.push(r.row);
        });
        if(this.state.userGroups.selectedRows)
          selectedRows = selectedRows.concat(this.state.userGroups.selectedRows);
        var userGroups = {...this.state.userGroups, rows: newRows, selectedRows: selectedRows}
        this.setState({userGroups});
      }

      const onRowsDeselected = (rows) => {
        let newRows = [...this.state.userGroups.rows];
        rows.map (r => {
         newRows[r.rowIdx].isSelected = false;
        });
        let selectedRows = [...this.state.userGroups.selectedRows];
        selectedRows = selectedRows.filter(function(obj){
          return obj.isSelected == true;
        })
        var userGroups = {...this.state.userGroups, rows: newRows, selectedRows: selectedRows};
        this.setState({userGroups});
      }

      const onRowClick = (rowIdx, row) => {
        this.setState({groupName: row.name}, () => { this.props.fetchGroupDetail(row.id) });
      }

      // Column difinition
      const columns = [
        {
          key: 'name',
          name: <Translate value="granted_group_name" />,
          resizable: true,
          width: 250,
          sortable: true,
          filterable: true
        }
      ]

      return (
          <Col sm={ 4 }>
            <div style={{ maxWidth: '100%' }} id="UserManagementDetail-dataGrid2">
              <ReactDataGrid
                rowRenderer={<RowRenderer onDoubleClick={this.moveOffUserGroups} />}
                rowKey='id'
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter={true}/>}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                minHeight={265}
                rowGetter={rowGetter}
                rowsCount={ getSize() }
                onRowClick={onRowClick}
                //   enableRowSelect='multi'
                //  rowSelection={{
                //    showCheckbox: true,
                //    enableShiftSelect: true,
                //    onRowsSelected: onRowsSelected,
                //    onRowsDeselected: onRowsDeselected,
                //    selectBy: {
                //     isSelectedKey: 'isSelected'
                //    }
                // }}
              />
            </div>
          </Col>
        )
      }
    }

    renderGroupsPermissions() {
      if (this.props.groupDetailIsLoading && !this.props.groupDetailError) return <Col sm={ 4 }><Spinner/></Col>
      else if (this.props.groupDetailError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.groupDetailError)}</div></ContentWrapper>
      else {
        // Parameters of the react-data-grid
        const getRows = () => {
          return Data.Selectors.getRows(this.state.groupPermissions);
        }

        const getSize = () => { return getRows().length; }

        const rowGetter = rowIdx => {
          var rows = getRows();
          return rows[rowIdx];
        }

        // Handle the sortable function
        const handleGridSort = (sortColumn, sortDirection) => {
          var groupPermissions = Object.assign({}, this.state.groupPermissions, { sortColumn: sortColumn, sortDirection: sortDirection });
          this.setState({groupPermissions});
        }

        const handleFilterChange = filter => {
          let newFilters = Object.assign({}, this.state.groupPermissions.filters);
          if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
          } else {
            delete newFilters[filter.column.key];
          }
          const groupPermissions = {...this.state.groupPermissions, filters: newFilters};
          this.setState({ groupPermissions });
        }

        // Handle the row select function
        const onRowsSelected = (rows) => {
          let newRows = [...this.state.groupPermissions.rows];
          let selectedRows = [];
          rows.map (r => {
            newRows[r.rowIdx].isSelected = true;
            selectedRows.push(r.row);
          });
          if(this.state.groupPermissions.selectedRows)
            selectedRows = selectedRows.concat(this.state.groupPermissions.selectedRows);
          var groupPermissions = {...this.state.groupPermissions, rows: newRows, selectedRows: selectedRows}
          this.setState({groupPermissions});
        }

        const onRowsDeselected = (rows) => {
          let newRows = [...this.state.groupPermissions.rows];
          rows.map (r => {
            newRows[r.rowIdx].isSelected = false;
          });
          let selectedRows = [...this.state.groupPermissions.selectedRows];
          selectedRows = selectedRows.filter(function(obj){
            return obj.isSelected == true;
          })
          var groupPermissions = {...this.state.groupPermissions, rows: newRows, selectedRows: selectedRows};
          this.setState({groupPermissions});
        }

        const onRowClick = (rowIdx, row) => {
        //  this.props.fetchUserDetail(row.user_id);
        }

        // Column difinition

        const columns = [
          {
            key: 'name',
            name: this.state.groupName || <Translate value="granted_permission_name" />,
            resizable: true,
            width: 300,
            sortable: true,
            filterable: true
          }
        ]

        return (
          <Col sm={ 4 }>
            <div style={{ maxWidth: '100%' }} className="group-permission-data-grid" id="UserManagementDetail-dataGrid3">
              <ReactDataGrid
                rowKey='id'
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter={true}/>}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                minHeight={265}
                rowGetter={rowGetter}
                rowsCount={ getSize() }
                onRowClick={onRowClick}
              />
            </div>
          </Col>
        )
      }
    }

    renderPermissions() {
      if (this.props.permissionsIsLoading && !this.props.permissionsError) return <Spinner/>
      else if (this.props.permissionsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.permissionsError)}</div></ContentWrapper>
      else {
        // Parameters of the react-data-grid
        const getRows = () => {
          return Data.Selectors.getRows(this.state.permissions);
        }

        const getSize = () => { return getRows().length; }

        const rowGetter = rowIdx => {
          var rows = getRows();
          return rows[rowIdx];
        }

        // Handle the sortable function
        const handleGridSort = (sortColumn, sortDirection) => {
          var permissions = Object.assign({}, this.state.permissions, { sortColumn: sortColumn, sortDirection: sortDirection });
          this.setState({permissions});
        }

        const handleFilterChange = filter => {
          let newFilters = Object.assign({}, this.state.permissions.filters);
          if(isVAK) {
            vakPermissionFilter(filter.column.key, filter.filterTerm)
            return
          }
          if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
          } else {
            delete newFilters[filter.column.key];
          }
          const permissions = {...this.state.permissions, filters: newFilters};
          this.setState({ permissions });
        }

        const vakPermissionFilter = (key, filterTerm) => {
          let newRows = [...this.state.currentPermissions];
          let cpRows = [];
          if(filterTerm) {
            let lowerFilter = filterTerm;
            if(typeof filterTerm === 'string') {
              lowerFilter = filterTerm.toString().toLowerCase()
            }
            newRows.map(item => {
              if(key == 'group_name') {
                let cn = (item.cn_group_name || '').indexOf(lowerFilter);
                let en = (item.group_name ? item.group_name.toString().toLowerCase() : '').indexOf(lowerFilter);
                if(cn != -1 || en != -1) {
                  cpRows.push({...item});
                }
              } else if(key == 'category_name') {
                let cn = (item.cn_category_name || '').indexOf(lowerFilter);
                let en = (item.category_name ? item.category_name.toString().toLowerCase() : '').indexOf(lowerFilter);
                if(cn != -1 || en != -1) {
                  cpRows.push({...item});
                }
              } else {
                let cn = (item.cn_name || '').indexOf(lowerFilter);
                let en = (item.name ? item.name.toString().toLowerCase() : '').indexOf(lowerFilter);
                if(cn != -1 || en != -1) {
                  cpRows.push({...item});
                }
              }
            })
          } else {
            cpRows = [...newRows]
          }
          const permissions = {...this.state.permissions, rows: cpRows};
          this.setState({ permissions });
        }
        // Handle the row select function
        const onRowsSelected = (rows) => {
          let newRows = [...this.state.permissions.rows];
          let selectedRows = [];
          rows.map (r => {
            newRows[r.rowIdx].isSelected = true;
            selectedRows.push(r.row);
          });
          if(this.state.permissions.selectedRows)
            selectedRows = selectedRows.concat(this.state.permissions.selectedRows);
          var permissions = {...this.state.permissions, rows: newRows, selectedRows: selectedRows}
          this.setState({permissions});
        }

        const onRowsDeselected = (rows) => {
          let newRows = [...this.state.permissions.rows];
          rows.map (r => {
            newRows[r.rowIdx].isSelected = false;
          });
          let selectedRows = [...this.state.permissions.selectedRows];
          selectedRows = selectedRows.filter(function(obj) {
           return obj.isSelected == true;
          })
          var permissions = {...this.state.permissions, rows: newRows, selectedRows: selectedRows};
          this.setState({permissions});
        }

        const onRowClick = (rowIdx, row) => {
            //  this.props.fetchUserDetail(row.user_id);
         }

        // Column difinition
        const columns = [
            {
              key: 'name',
              name: <Translate value="permission_name" />,
              resizable: true,
              width: 300,
              sortable: true,
              filterable: true,
              getRowMetaData: row => row,
              formatter: ({dependentValues, value}) => {
                  if ( isVAK ) {
                    return <span><TranslateNamePermission data={dependentValues} columnFlag='permission'/></span>
                  } else {
                    return <span>{value}</span>
                  }
              }
            }
          ]
          if (isVAK) {
            columns.unshift({
              key: 'group_name',
              name: <Translate value="group_name_permission" />,
              resizable: true,
              width: 150,
              sortable: true,
              filterable: true,
              getRowMetaData: row => row,
              formatter: ({dependentValues, value}) => {
                return <span><TranslateNamePermission data={dependentValues} columnFlag='group'/></span>
              }
            },{
              key: 'category_name',
              name: <Translate value="category_name_permission" />,
              resizable: true,
              width: 200,
              sortable: true,
              filterable: true,
              getRowMetaData: row => row,
              formatter: ({dependentValues, value}) => {
                return <span><TranslateNamePermission data={dependentValues} columnFlag='category'/></span>
              }
            })
          }

        return (
          <Col sm={ 6 }>
            <div style={{ maxWidth: '100%' }} id="UserManagementDetail-dataGrid4">
              <ReactDataGrid
                rowRenderer={<RowRenderer onDoubleClick={this.moveToUserPermissions} />}
                rowKey='id'
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter={true}/>}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                minHeight={265}
                rowGetter={rowGetter}
                rowsCount={ getSize() }
                onRowClick={onRowClick}
                //   enableRowSelect='multi'
                rowSelection={{
                  showCheckbox: true,
                  enableShiftSelect: true,
                  onRowsSelected: onRowsSelected,
                  onRowsDeselected: onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected'
                  }
                }}
              />
            </div>
          </Col>
        )
      }
    }

    renderUserPermissions() {
      if (this.props.permissionsIsLoading && !this.props.permissionsError) return <Spinner/>
      else if (this.props.permissionsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.permissionsError)}</div></ContentWrapper>
      else {
        // Parameters of the react-data-grid
        const getRows = () => {
          return Data.Selectors.getRows(this.state.userPermissions);
        }

        const getSize = () => {
          return getRows().length;
        }

        const rowGetter = rowIdx => {
          var rows = getRows();
          return rows[rowIdx];
        }

        // Handle the sortable function
        const handleGridSort = (sortColumn, sortDirection) => {
          var userPermissions = Object.assign({}, this.state.userPermissions, { sortColumn: sortColumn, sortDirection: sortDirection });
          this.setState({userPermissions});
        }

        const handleFilterChange = filter => {
          let newFilters = Object.assign({}, this.state.userPermissions.filters);
          if(isVAK) {
            vakUserPermissionFilter(filter.column.key, filter.filterTerm)
            return
          }
          if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
          } else {
            delete newFilters[filter.column.key];
          }
          const userPermissions = {...this.state.userPermissions, filters: newFilters};
          this.setState({ userPermissions });
        }

        const vakUserPermissionFilter = (key, filterTerm) => {
          let newRows = [...this.state.currentUserPermissions];
          let cpRows = [];
          if(filterTerm) {
            let lowerFilter = filterTerm;
            if(typeof filterTerm === 'string') {
              lowerFilter = filterTerm.toString().toLowerCase()
            }
            newRows.map(item => {
              if(key == 'group_name') {
                let cn = (item.cn_group_name || '').indexOf(lowerFilter);
                let en = (item.group_name ? item.group_name.toString().toLowerCase() : '').indexOf(lowerFilter);
                if(cn != -1 || en != -1) {
                  cpRows.push({...item});
                }
              } else if(key == 'category_name') {
                let cn = (item.cn_category_name || '').indexOf(lowerFilter);
                let en = (item.category_name ? item.category_name.toString().toLowerCase() : '').indexOf(lowerFilter);
                if(cn != -1 || en != -1) {
                  cpRows.push({...item});
                }
              } else {
                let cn = (item.cn_name || '').indexOf(lowerFilter);
                let en = (item.name ? item.name.toString().toLowerCase() : '').indexOf(lowerFilter);
                if(cn != -1 || en != -1) {
                  cpRows.push({...item});
                }
              }
            })
          } else {
            cpRows = [...newRows]
          }
          const userPermissions = {...this.state.userPermissions, rows:cpRows};
          this.setState({ userPermissions });
        }

        // Handle the row select function
        const onRowsSelected = (rows) => {
          let newRows = [...this.state.userPermissions.rows];
          let selectedRows = [];
          rows.map (r => {
            newRows[r.rowIdx].isSelected = true;
            selectedRows.push(r.row);
          });
          if(this.state.userPermissions.selectedRows)
            selectedRows = selectedRows.concat(this.state.userPermissions.selectedRows);
          var userPermissions = {...this.state.userPermissions, rows: newRows, selectedRows: selectedRows}
          this.setState({userPermissions});
        }

        const onRowsDeselected = (rows) => {
          let newRows = [...this.state.userPermissions.rows];
          rows.map (r => {
            newRows[r.rowIdx].isSelected = false;
          });
          let selectedRows = [...this.state.userPermissions.selectedRows];
          selectedRows = selectedRows.filter(function(obj){
            return obj.isSelected == true;
          })
          var userPermissions = {...this.state.userPermissions, rows: newRows, selectedRows: selectedRows};
          this.setState({userPermissions});
        }

        const onRowClick = (rowIdx, row) => {
          //  this.props.fetchUserDetail(row.user_id);
        }

        // Column difinition
        const columns = [
          {
            key: 'name',
            name: <Translate value="granted_permission_name" />,
            resizable: true,
            width: 300,
            sortable: true,
            filterable: true,
            getRowMetaData: row => row,
            formatter: ({dependentValues, value}) => {
                if ( isVAK ) {
                  return <span><TranslateNamePermission data={dependentValues}/></span>
                } else {
                  return <span>{value}</span>
                }
            }
          }
        ]
        if (isVAK) {
          columns.unshift({
            key: 'group_name',
            name: <Translate value="group_name_permission" />,
            resizable: true,
            width: 150,
            sortable: true,
            filterable: true,
            getRowMetaData: row => row,
            formatter: ({dependentValues, value}) => {
              return <span><TranslateNamePermission data={dependentValues} columnFlag='group'/></span>
               
            }
          },{
            key: 'category_name',
            name: <Translate value="category_name_permission" />,
            resizable: true,
            width: 200,
            sortable: true,
            filterable: true,
            getRowMetaData: row => row,
            formatter: ({dependentValues, value}) => {
              return <span><TranslateNamePermission data={dependentValues} columnFlag='category'/></span>
            }
          })
        }
        return (
          <Col sm={ 6 }>
            <div style={{ maxWidth: '100%' }} id="UserManagementDetail-dataGrid5">
              <ReactDataGrid
                rowRenderer={<RowRenderer onDoubleClick={this.moveOffUserPermissions} />}
                rowKey='id'
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter={true}/>}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                minHeight={265}
                rowGetter={rowGetter}
                rowsCount={ getSize() }
                onRowClick={onRowClick}
                //   enableRowSelect='multi'
                rowSelection={{
                  showCheckbox: true,
                  enableShiftSelect: true,
                  onRowsSelected: onRowsSelected,
                  onRowsDeselected: onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected'
                  }
                }}
              />
            </div>
          </Col>
        )
      }
    }

    resetPassword = () => {
      const letter = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 4);
      const password = `${letter}1234`;
      const url = RESET_PASSWORD_URL + this.props.userDetail.User_id;

      axios.put(
        url,
        { password },
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        },
      ).then((response) => {
          if (response.status === 200) {
            alert(`Reset password to: ${password}`);
          }
        })
        .catch((error) => {
          alert("Could not reset password, please try again!");
        });
      this.setState({
        showPasswordPopup: false,
      });
    };

    deleteUser = () => {
      const url = DELETE_USER_URL + this.props.userDetail.BaseUser_id;
      axios.delete(
        url,
        {
           data: { id: "BaseUser_id" } ,
           headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        },
      ).then((response) => {
          if (response.status === 200) {
            alert("The user has been deleted!");
          }
        })
        .catch((error) => {
          alert("Could not delete user, please try again!");
        })
       this.setState({
         deleteUserPopup: false,
      });
    };
    
    getCustomers() {
      let Customers = [];
      this.props.customers.map((customer) => {
        Customers.push({ value: customer.Customer_id, label: customer.Name });
      });
      return Customers;
    }

    moveToUserPermissions(permission) {
      let userPermissionsRows = [...this.state.userPermissions.rows];
      let newRows = [...this.state.permissions.rows];
      let cpUserPermissionRows = [...this.state.currentUserPermissions];
      let cpPermissionRows = [...this.state.currentPermissions];
      let currentPermissions = [];
      let currentUserPermissions = [];
      let index = _.findIndex(newRows, {id: permission.id});
      if (index > -1) {
        newRows.splice(index, 1);
      }
      if(isVAK) {
        let perIndex = _.findIndex(cpPermissionRows, {id: permission.id});
        if(perIndex > -1) {
          cpPermissionRows.splice(perIndex, 1);
        }
        let userIndex = _.findIndex(cpUserPermissionRows, {id: permission.id})
        if(userIndex == -1) {
          cpUserPermissionRows.push({...permission, isSelected: false});
        }
        currentPermissions.push(...cpPermissionRows.sort((a,b) => {return a.name.localeCompare(b.name)}));
        currentUserPermissions.push(...cpUserPermissionRows);
      }
      index = _.findIndex(userPermissionsRows, {id: permission.id})
      if (index == -1) {
        userPermissionsRows.push({...permission, isSelected: false});
      }
      let userPermissions = {...this.state.userPermissions, rows: userPermissionsRows};
      let permissions = {...this.state.permissions, rows: newRows.sort((a,b) => {return a.name.localeCompare(b.name)})};
      this.setState({userPermissions: userPermissions, permissions: permissions, currentPermissions, currentUserPermissions});
    }

    moveOffUserPermissions(permission) {
      let userPermissionsRows = [...this.state.userPermissions.rows];
      let newRows = [...this.state.permissions.rows];
      let cpUserPermissionRows = [...this.state.currentUserPermissions];
      let cpPermissionRows = [...this.state.currentPermissions];
      let currentPermissions = [];
      let currentUserPermissions = [];
      let index = _.findIndex(userPermissionsRows, {id: permission.id});
      if (index > -1) {
        userPermissionsRows.splice(index, 1);
      }
      if(isVAK) {
        let userIndex = _.findIndex(cpUserPermissionRows, {id: permission.id});
        if(userIndex > -1) {
          cpUserPermissionRows.splice(userIndex, 1);
        }
        let perIndex = _.findIndex(cpPermissionRows, {id: permission.id})
        if(perIndex == -1) {
          cpPermissionRows.push({...permission, isSelected: false});
        }
        currentPermissions.push(...cpPermissionRows.sort((a,b) => {return a.name.localeCompare(b.name)}));
        currentUserPermissions.push(...cpUserPermissionRows);
      }
      index = _.findIndex(newRows, {id: permission.id})
      if (index == -1) {
        newRows.push({...permission, isSelected: false});
      }
      let userPermissions = {...this.state.userPermissions, rows: userPermissionsRows};
      let permissions = {...this.state.permissions, rows: newRows.sort((a,b) => {return a.name.localeCompare(b.name)})};
      this.setState({userPermissions: userPermissions, permissions: permissions, currentPermissions, currentUserPermissions});
    }

    moveAllPermissions() {
      let permissionsRows = [...this.state.permissions.rows];
      let userPermissionsRows = [...this.state.userPermissions.rows];
      let cpUserPermissionRows = [...this.state.currentUserPermissions];
      let cpPermissionRows = [...this.state.currentPermissions];
      let index;
      let userIndex;
      if(isVAK) {
        cpPermissionRows.map(r => {
          index = _.findIndex(userPermissionsRows, {id: r.id})
          if (index == -1) { userPermissionsRows.push(r); }
          userIndex = _.findIndex(cpUserPermissionRows, {id: r.id})
          if (userIndex == -1) { cpUserPermissionRows.push(r); }
        })
      } else {
        permissionsRows.map(r => {
          index = _.findIndex(userPermissionsRows, {id: r.id})
          if (index == -1) { userPermissionsRows.push(r); }
          if(isVAK) {
            userIndex = _.findIndex(cpUserPermissionRows, {id: r.id})
            if (userIndex == -1) { cpUserPermissionRows.push(r); }
          }
        })
      }
      let userPermissions = {...this.state.userPermissions, rows: userPermissionsRows};
      let permissions = {...this.state.permissions, rows: []};
      this.setState({userPermissions: userPermissions, permissions: permissions, currentUserPermissions: cpUserPermissionRows, currentPermissions:[]});
    }

    moveSelectedDisabled() {
      let { permissions } = this.state;
      if (permissions.selectedRows && permissions.selectedRows.length > 0) {
        return false;
      } else {
        return true;
      }
    }

    moveSelectedPermissions() {
      let userPermissionsRows = [...this.state.userPermissions.rows];
      let permissionsRows = [...this.state.permissions.rows];
      let cpUserPermissionRows = [...this.state.currentUserPermissions];
      let cpPermissionRows = [...this.state.currentPermissions];
      let newRows = [...this.state.permissions.rows];
      let selectedPermissionRows = [...this.state.permissions.selectedRows];
      let index;
      let perIndex;
      let userIndex;
      
      if(isVAK) {
        this.state.currentPermissions.map(r => {
          selectedPermissionRows.map(s => {
            if (r.id === s.id) {
              index = _.findIndex(newRows, {id: r.id});
              if (index > -1) {
                newRows.splice(index, 1);
              }
              index = _.findIndex(userPermissionsRows, { id: r.id })
              if (index == -1) {
                userPermissionsRows.push({...r, isSelected: false});
              }
              perIndex = _.findIndex(cpPermissionRows, {id: r.id});
              if (perIndex > -1) {
                cpPermissionRows.splice(perIndex, 1);
              }
              userIndex = _.findIndex(cpUserPermissionRows, { id: r.id })
              if (userIndex == -1) {
                cpUserPermissionRows.push({...r, isSelected: false});
              }
            }
          })
        })
      } else {
        permissionsRows.map(r => {
          selectedPermissionRows.map(s => {
            if (r.id === s.id) {
              index = _.findIndex(newRows, {id: r.id});
              if (index > -1) {
                newRows.splice(index, 1);
              }
              index = _.findIndex(userPermissionsRows, { id: r.id })
              if (index == -1) {
                userPermissionsRows.push({...r, isSelected: false});
              }
            }
          })
        })
      }
      let userPermissions = {...this.state.userPermissions, rows: userPermissionsRows};
      let permissions = {...this.state.permissions, selectedRows: [], rows: newRows.sort((a,b) => {return a.name.localeCompare(b.name)})};
      if(isVAK) {
        this.setState({userPermissions: userPermissions, permissions: permissions, 
          currentPermissions:cpPermissionRows.sort((a,b) => {return a.name.localeCompare(b.name)}),
          currentUserPermissions: cpUserPermissionRows,
        });
      } else {
        this.setState({userPermissions: userPermissions, permissions: permissions});
      }
    }

    moveToUserGroups(group) {
      let userGroupsRows = [...this.state.userGroups.rows];
      let newRows = [...this.state.groups.rows];
      let index = _.findIndex(newRows, {id: group.id});
      if (index > -1) {
        newRows.splice(index, 1);
      }
      index = _.findIndex(userGroupsRows, {id: group.id})
      if (index == -1) {
        userGroupsRows.push(group);
      }
      let userGroups = {...this.state.userGroups, rows: userGroupsRows};
      let groups = {...this.state.groups, rows: newRows.sort((a,b) => {return a.name.localeCompare(b.name)})};
      this.setState({userGroups: userGroups, groups: groups});
    }

    moveOffUserGroups(group) {
      let userGroupsRows = [...this.state.userGroups.rows];
      let newRows = [...this.state.groups.rows];
      let index = _.findIndex(userGroupsRows, {id: group.id});
      if (index > -1) {
        userGroupsRows.splice(index, 1);
      }
      index = _.findIndex(newRows, {id: group.id})
      if (index == -1) {
        newRows.push(group);
      }
      let userGroups = {...this.state.userGroups, rows: userGroupsRows};
      let groups = {...this.state.groups, rows: newRows.sort((a,b) => {return a.name.localeCompare(b.name)})};
      this.setState({userGroups: userGroups, groups: groups});
    }

    handleFormSubmit(originalFormProp) {
      const customerIds = [];
      if (isKM && originalFormProp.CustomerIds && originalFormProp.CustomerIds.length > 0) {
        originalFormProp.CustomerIds.map(customer => {
          customerIds.push(customer.value);
        });
      }
      
      const formProps = {
        ...originalFormProp,
        IsOfficeOnly: this.state.IsOfficeOnly,
        Position: !originalFormProp.Position ? '' : ((originalFormProp.Position.value === undefined) ? originalFormProp.Position : originalFormProp.Position.value),
        Customers: customerIds,
      }
      
      this.setState({ dirty: false });
      const props = {
        ...formProps,
        id: formProps.BaseUser_id,
        email: formProps.email ? formProps.email : '',
        FirstName: formProps.FirstName,
        LastName: formProps.LastName,
        Cellphone: formProps.Cellphone,
        Commission: formProps.Commission,
        Customers: customerIds,
      };
      if (this.props.currentUser) {
        if (!this.checkPermission("change_baseuser")) {
          if(isVAK) {
            this.props.editUserDetail(props, this.state.currentUserPermissions, Data.Selectors.getRows(this.state.userGroups), 1);
          } else {
            this.props.editUserDetail(props, Data.Selectors.getRows(this.state.userPermissions), Data.Selectors.getRows(this.state.userGroups), 1);
          }
        } else {
          alert("You have no permission!");
        }
      } else {
        if(isVAK) {
          this.props.createUserDetail(formProps, this.state.currentUserPermissions, Data.Selectors.getRows(this.state.userGroups));
        } else {
          this.props.createUserDetail(formProps, Data.Selectors.getRows(this.state.userPermissions), Data.Selectors.getRows(this.state.userGroups));
        }
      }
  
      if (formProps.username === localStorage.getItem('username')) {
        alert('You changed your own permissions, please logout and log back in for the permissions to take affect.');
      }
    }

    renderPassword() {
      return (
        <Col sm={ 3 }>
          <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="password" /></label></Col>
          <Col sm={ 6 } style={{float: "left"}}>
            <Field className="largeInput" name="password" component={PasswordInputField} />
          </Col>
        </Col>
      )
    }
    
    renderPasswordConfirm() {
      return (
        <Col sm={ 3 }>
          <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="confirm_password" /></label></Col>
          <Col sm={ 6 } style={{float: "left"}}>
            <Field className="largeInput" name="passwordConfirm" component={PasswordInputField} />
          </Col>
        </Col>
      )
    }

    handleAdminChange = (value) => {
      this.setState({ admin: value })
    }
    
    renderAdminPasscode() {
      return (
        <Col sm={ 3 }>
        {
          //keep the commentout code. customer might want to change their mind
        }
          {/* <Col sm={ 6 }>
            <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="admin" /></label></Col>
            <Col sm={ 6 } style={{float: "left", marginTop: '4px'}}>
              <Translate value="yes" />
              <input style={{marginLeft: '4px'}} type="radio" name="admin" checked={this.state.admin === 'yes'} id="yes" onChange={e => this.handleAdminChange('yes')} />
              <Translate value="no" />
              <input style={{marginLeft: '4px'}} type="radio" name="admin" checked={this.state.admin === 'no'} id="no" onChange={e => this.handleAdminChange('no')} />
            </Col>
          </Col> */}
          <Col sm={ 6 }>
            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="pass_code" /></label>
          </Col>
          <Col sm={ 6 } style={{float: "left"}}>
            <Field className="largeInput" name="passcode" component={PasswordInputField} />
          </Col>
        </Col>
      )
    }

    renderPosition() {
      return (
        <Col sm={ 3 }>
          <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="position" /></label></Col>
          <Col sm={ 6 } style={{float: "left", zIndex: '99'}}>
            <Field 
              name="Position"
              component={ Selection }
              options={positionOptions}
            />
          </Col>
        </Col>
      )
    }

    renderIsOfficeOnly = () => {
      const { IsOfficeOnly } = this.state;
      return (
        <Col sm={ 3 }>
          <Col sm={ 12 }>
            <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" >
              <Translate value="office_only" /></label>
            </Col>
            <Col sm={ 6 } style={{float: "left"}}>
              <input
                checked={IsOfficeOnly}
                onChange={(e) => this.setState({
                  IsOfficeOnly: e.target.checked,
                })}
                type="checkbox"
              />
            </Col>
          </Col>
        </Col>
      )
    }

    renderName() {
      if (this.props.currentUser) {
        return (
          <Col sm={ 3 }>
            <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="user_name" /></label></Col>
            <Col sm={ 6 } style={{float: "left"}}>
              <Field className="largeInput" name="username" component={ DisabledInputField } placeholder={this.props.userDetail ? this.props.userDetail.username : null}/>
            </Col>
          </Col>
        )
      } else {
        return (
          <Col sm={ 3 }>
            <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="user_name" /></label></Col>
            <Col sm={ 6 } style={{float: "left"}}>
              <Field className="largeInput" name="username" component={ InputField } />
            </Col>
          </Col>
        )
      }
    }
    
    openAssignCustomer() {
      this.setState({ assignCustomerOpen: true});
    }

    closeAssignCustomer() {
      this.setState({ assignCustomerOpen: false});
    }

    openEditUserName() {
      this.setState({editUserNameOpen: true});
    }

    closeEditUserName() {
      this.setState({editUserNameOpen: false});
      this.props.fetchUserDetail(this.props.currentUser);
    }

    openEditPassword() {
      this.props.resetPassword();
      this.setState({editPasswordOpen: true});
    }

    closeEditPassword() {
      this.setState({editPasswordOpen: false});
    }

    closeResetPasswordPopup() {
      this.setState({showPasswordPopup: false});
    }

    closeDeleteUserPopup(){
      this.setState({deleteUserPopup: false});
    }

    checkPermission(permission) {
        return false;
    }

    checkAuthorize(password) {
      this.props.checkPassword(password);
    }

    openResetPasswordPopup() {
      this.setState({ showPasswordPopup: true });
      this.props.clearCheckPassword();
    }

    openDeleteUserPopup() {
      this.setState({ deleteUserPopup: true });
      this.props.clearCheckPassword();
    }

    renderError() {
      if(this.props.createUserDetailError) {
        return <ContentWrapper><div className="alert alert-danger">{ this.props.createUserDetailError.data }</div></ContentWrapper>
      }
      return;
    }

    handleCompanySelect = (company = {}, callback = () => {}) => {
      this.props.changeFieldValue('Warehouse_id', '');
      if (company && company.value) {
        this.props.fetchWarehouseWithCompanyId(company.value, callback);
      }
    }

    render() {
      let createDialogStyle = {
        height: '300px',
        width: '600px',
        marginLeft: '-10%',
      };
      const { handleSubmit, submitting, pristine } = this.props;
      const assignCustomer = (<Translate value="assign_customer" />);
      const editUsername = (<Translate value="edit_username" />);
      const changePassword = (<Translate value="change_password" />);
      const resetPassword = (<Translate value="reset_password" />);
      const deleteUser = (<Translate value="delete_user" />);
      let Customers = [];
      if (isKM) { Customers = this.getCustomers(); }
      return (
        <ContentWrapper>
          <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) }>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="admin" />
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Translate value="user_management" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active="true">
              <Translate value="user_detail" />
            </Breadcrumb.Item>
          </Breadcrumb>
          <ButtonToolbar>
            <Button type="submit" bsStyle="success" ><em className="fa fa-save"/> <Translate value="save" />
            </Button>
            {
              isKM &&
              <Button bsStyle="primary" onClick={ this.openAssignCustomer } disabled={this.checkPermission("change_baseuser")} ><Translate value="assign_cust" />
              </Button>
            }
            <Button bsStyle="primary" onClick={ this.openEditUserName } disabled={this.checkPermission("change_baseuser")} ><Translate value="edit_username" />
            </Button>
            <Button bsStyle="primary" onClick={ this.openEditPassword } disabled={this.checkPermission("change_baseuser")} ><Translate value="edit_password" />
            </Button>
            <Button bsStyle="primary" onClick={this.openResetPasswordPopup} disabled={this.checkPermission("change_baseuser")} ><Translate value="reset_password" />
            </Button>
            <Button bsStyle="danger" onClick={this.openDeleteUserPopup} disabled={this.checkPermission("change_baseuser")} ><Translate value="delete_user" />
            </Button>
            <Button bsStyle="danger" onClick={()=>{this.context.router.push('/userManagement')}}><em className="fa fa-close"/>
            </Button>
          </ButtonToolbar>
          <Grid id="user-management-detail">
            { this.renderError() }
            <Row className="marginBottomStyle" >
              <Panel>
                <Row style={{ marginTop: 6 }}>
                  {this.renderName()}
                  <Col sm={ 3 }>
                    <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="email" /></label></Col>
                    <Col sm={ 6 } style={{float: "left"}}>
                      <Field name="email" component={ InputField }/>
                    </Col>
                  </Col>
                  {!this.props.userDetail && this.renderPassword()}
                  {!this.props.userDetail && this.renderPasswordConfirm()}
                </Row>
                <Row>
                  <Col sm={ 3 }>
                    <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="first_name" /></label></Col>
                      <Col sm={ 6 } style={{float: "left"}}>
                        <Field name="FirstName" component={ InputField }/>
                      </Col>
                    </Col>
                    <Col sm={ 3 }>
                    <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="last_name" /></label></Col>
                    <Col sm={ 6 } style={{float: "left"}}>
                      <Field name="LastName" component={ InputField }/>
                    </Col>
                  </Col>
                  { this.renderAdminPasscode() }
                </Row>
                <Row>
                  <Col sm={ 3 }>
                    <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="company" /></label></Col>
                    <Col sm={ 6 } style={{float: "left"}}>
                      <Field
                        name="Company_id"
                        matchPos="any"
                        placeholder={
                          <span>
                            <Translate value="default_company" />
                            <span className="asteriksReq" >*</span>
                          </span>
                        }
                        onSelect={company => {
                          // this.props.handleCompanySelect();
                          this.handleCompanySelect(company);
                        }}
                        component={SelectionWithProps}
                        options={this.props.companyOptions}
                      />
                    </Col>
                  </Col>
                  <Col sm={ 3 }>
                    <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="warehouse" /></label></Col>
                    <Col sm={ 6 } style={{float: "left"}}>
                      <Field
                        name="Warehouse_id"
                        matchPos="any"
                        placeholder={
                          <span>
                            <Translate value="default_warehouse" />
                            <span className="asteriksReq" >*</span>
                          </span>
                        }
                        onSelect={warehouse => {
                          // this.props.handleCompanySelect();
                          // this.handleCompanySelect(company.value);
                        }}
                        component={SelectionWithProps}
                        options={this.props.warehouseOptions}
                      />
                    </Col>
                  </Col>
                  { this.renderPosition()}
                </Row>
                <Row>
                  <Col sm={ 3 }>
                    <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="phone" /></label></Col>
                    <Col sm={ 6 } style={{float: "left"}}>
                      <Field name="Cellphone" component={ InputField }/>
                    </Col>
                  </Col>
                  {
                    isSV &&
                    <Col sm={ 3 }>
                      <Col sm={ 6 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="commission_rate" /></label></Col>
                      <Col sm={ 6 } style={{float: "left"}}>
                        <Field name="Commission" component={ InputField }/>
                      </Col>
                    </Col>
                  }
                </Row>
              </Panel>
            </Row>
            <Row>
              <Panel id="user-management-detail-groups">
                { this.renderGroups() }
                { this.renderUserGroups() }
                { this.renderGroupsPermissions() }
              </Panel>
            </Row>
            <Row>
              <Panel id="user-management-detail-permissions">
                <ButtonToolbar>
                  <Button style={{marginLeft: "15px"}} bsStyle="primary" onClick={()=>{this.moveAllPermissions()}}><Translate value="move_all" /></Button>
                  <Button bsStyle="primary" disabled={this.moveSelectedDisabled()} onClick={()=>{this.moveSelectedPermissions()}}><Translate value="move_selected" /></Button>
                </ButtonToolbar>
                { this.renderPermissions() }
                { this.renderUserPermissions() }
              </Panel>
            </Row>
            <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.assignCustomerOpen} onCloseClicked={
                this.closeAssignCustomer.bind(this)} title={assignCustomer}>
              <div>
                <Row><Col xs={12} style={{ marginTop: '20px' }}>
                  <label style={{ paddingTop: '2px' }}>
                    <Translate value="customer" />
                  </label>
                  <Field 
                    name="CustomerIds"
                    placeholder={<span><Translate value="select" /></span>}
                    component={SelectionWithProps}
                    multi={true}
                    options={Customers}
                  />
                </Col></Row>
                <Row style={{ marginTop: '80px', textAlign: 'center' }}>
                  <button className="btn btn-primary buttonStyle" onClick={()=>{this.closeAssignCustomer()}}>
                    <Translate value="done" />
                  </button>
                </Row>
              </div>
            </SkyLightStateless>
            <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.editUserNameOpen} onCloseClicked={
                this.closeEditUserName.bind(this)} title={editUsername}>
              <UserName userDetail={this.props.userDetail} handleSubmit={() => {handleSubmit(this.handleFormSubmit.bind(this));}}/>
            </SkyLightStateless>
            <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.editPasswordOpen} onCloseClicked={
                this.closeEditPassword.bind(this)} title={changePassword}>
              <UserPassword userDetail={this.props.userDetail} isMainUser={false}/>
            </SkyLightStateless>
            <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.showPasswordPopup} onCloseClicked={
                this.closeResetPasswordPopup.bind(this)} title={resetPassword}>
              <ConfirmActionModal 
                case="confirmPassword" closeC={this.checkAuthorize}
                checkPasswordFailure={this.props.checkPasswordFailure}
                checkPasswordSuccess={this.props.checkPasswordSuccess}
                clearCheckPassword={this.props.clearCheckPassword}
              />                     
            </SkyLightStateless>
            <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.deleteUserPopup} onCloseClicked={
                this.closeDeleteUserPopup.bind(this)} title={deleteUser}>
              <ConfirmActionModal 
                case="confirmPassword" closeC={this.checkAuthorize}
                checkPasswordFailure={this.props.checkPasswordFailure}
                checkPasswordSuccess={this.props.checkPasswordSuccess}
                clearCheckPassword={this.props.clearCheckPassword}
              />                     
            </SkyLightStateless>
          </Grid>
        </form>
      </ContentWrapper>
    )
  }
}

UserManagementDetail.propTypes = {
  clearCheckPassword: PropTypes.func.isRequired,
  checkPassword: PropTypes.func.isRequired,
  checkPasswordSuccess: PropTypes.bool.isRequired,
  checkPasswordFailure: PropTypes.bool.isRequired,
};

export default UserManagementDetail;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/userManagementDetail.jsx